
<script>
import request from "./request.vue";
import session from "./session.vue";

export default {


  register: async function(data) {
    try {
      const resp =  await request.send('https://api.japanparts.com.br/api/newsletters', data, false, 'post');
      resp.success = true;
      return resp;
    } catch (error) {
      const resp = {...error, succes:false}
      return resp
    }
	}
};
</script>



// WEBPACK FOOTER //
// src/api/newsletter.vue